module.exports = __webpack_public_path__ + "static/media/arrow-svgrepo-com (2).270a5436.svg";